import {EcommerceSettingsService} from '../services/EcommerceSettingsService';

export class PaymentMethodStore {
  private isCheckoutRegularFlowEnabled: boolean = false;
  private hasLoadedPaymentMethods: boolean = false;
  private readonly ecommerceSettingsService: EcommerceSettingsService;
  constructor({ecommerceSettingsService}: {ecommerceSettingsService: EcommerceSettingsService}) {
    this.ecommerceSettingsService = ecommerceSettingsService;
  }
  public async init() {
    const [hasRegularFlowPaymentMethods, hasNoPaymentMethods, hasEWalletPaymentMethods] = await Promise.all([
      this.ecommerceSettingsService.hasRegularFlowPaymentMethods(),
      this.ecommerceSettingsService.hasAnyPaymentMethods().then((hasAnyPaymentMethods) => !hasAnyPaymentMethods),
      this.ecommerceSettingsService.hasEWalletPaymentMethods(),
    ]);

    this.isCheckoutRegularFlowEnabled = hasRegularFlowPaymentMethods || hasNoPaymentMethods || hasEWalletPaymentMethods;
    this.hasLoadedPaymentMethods = true;
    return this.isCheckoutRegularFlowEnabled;
  }

  public toProps() {
    return {
      hasLoadedPaymentMethods: this.hasLoadedPaymentMethods,
      isCheckoutRegularFlowEnabled: this.isCheckoutRegularFlowEnabled,
    };
  }
}
